import { useContext } from "react";
import classnames from "classnames";
import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { MultiStepPanelContext } from "./index";

export interface StepProps {
  children?: React.ReactNode;
  displayNext?: boolean;
  displaySkip?: boolean;
  displaySubmit?: boolean;
  isNextStepDisabled?: boolean;
  sequence: number;
  status: string;
  title: string;
}

export const Step = ({
  sequence,
  status,
  title,
  displayNext = false,
  displaySkip = false,
  displaySubmit = false,
  isNextStepDisabled,
  children,
}: StepProps) => {
  const panelContext = useContext(MultiStepPanelContext);
  const onNextClick = panelContext?.onNextClick;

  return (
    <div
      key={title}
      className={classnames("multi-step-panel__step", {
        hidden: status !== "active",
      })}
    >
      {children}
      <div className="multi-step-panel__actions">
        {displayNext && (
          <Button
            variant="primary"
            large
            onClick={(event: any) => onNextClick?.(event, sequence)}
            {...(isNextStepDisabled ? { disabled: true } : {})}
          >
            {t("next")}
          </Button>
        )}
        {displaySkip && (
          <Button
            variant="secondary"
            large
            onClick={(event: any) => onNextClick?.(event, sequence)}
            {...(isNextStepDisabled ? { disabled: true } : {})}
          >
            {t("skip")}
          </Button>
        )}
        {displaySubmit && (
          <Button
            variant="primary"
            large
            {...(isNextStepDisabled ? { disabled: true } : {})}
          >
            {t("finish")}
          </Button>
        )}
      </div>
    </div>
  );
};
